import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const SettingsMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSettingsClick = () => {
    setIsOpen(false);
    navigate('/settings');
  };

  return (
    <div className="settings-menu" ref={menuRef}>
      <button 
        className="settings-button"
        onClick={() => setIsOpen(!isOpen)}
        title="Settings"
      >
        ⚙️
      </button>
      
      {isOpen && (
        <div className="settings-dropdown">
          <button 
            className="dropdown-item"
            onClick={handleSettingsClick}
          >
            <span className="dropdown-icon"></span>
            Settings
          </button>
        </div>
      )}
    </div>
  );
};

export default SettingsMenu;
